import { securedAxios } from "../lib/axios";
import urljson from "../lib/urljson";

export default {
  namespaced: true,
  state: {
    cnab: [],
  },
  mutations: {
    carregar(state, cnab) {
      state.cnab = [];
      state.cnab = cnab;
    },
  },
  actions: {
    async listar({ commit }, opcoes) {
      try {
        const response = await securedAxios.get(
          `/cnab?opcoes=${urljson(opcoes)}`
        );
        commit("carregar", response.data);
        return Promise.resolve(response);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    async gravar(context, cnabInfo) {
      try {
        if (cnabInfo.id == "") {
          delete cnabInfo.id;
          await securedAxios.post("/cnab", cnabInfo);
        } else {
          var id = cnabInfo.id;
          delete cnabInfo.id;
          await securedAxios.put("/cnab/" + id, cnabInfo);
        }

        return Promise.resolve(true);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    buscaCnab(context, arquivo) {
      return securedAxios.get(`/cnab/${arquivo}`);
    },
    carregarCnab(context, DadosCnab) {
      return securedAxios.post("/cnab", DadosCnab);
    },
    async carregarBancos() {
      return securedAxios.get("/bancos");
    },
    deletar(context, id) {
      try {
        const response = securedAxios.delete("/cnab/" + id.id);
        return Promise.resolve(response);
      } catch (err) {
        return Promise.reject(err);
      }
    },
    async retornaDados(context, opcoes) {
      try {
        const response = await securedAxios.get(
          `/cnab?opcoes=${urljson(opcoes)}`
        );

        return Promise.resolve(response.data);
      } catch (e) {
        return Promise.reject(e);
      }
    },
  },
};
